export default __webpack_public_path__ + "static/auto-layout-do-light-22d3dd6c890b2e281801b52ac8b224d5.png";